// src/CiqlerDetail.js
import React from "react";
import "./GroNutrui.css";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

function GroNutruiDetail() {
  return (
    <div>
      <nav className="navbar">
        <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
          <h1>Ziad Aly</h1>
        </Link>
      </nav>
      <div className="mainbackground">
        <div className="gronutrui-project-detail notion-style">
          <div
            className="gronutrui-video-container"
            style={{ marginLeft: "300px" }}
          >
            <video
              controls
              width="50%"
              src={`${process.env.PUBLIC_URL}/./GroNatur.mp4`}
            />
          </div>
          <div className="detail-content">
            <div className="text-container">
              <h1>GroNutrui</h1>
              <div className="projectImageg">
                <img src={`${process.env.PUBLIC_URL}/gronutri.png`} />
              </div>
              <h2>Problem Statement</h2>
              <p>
                Shoppers struggle with evaluating nutritional value, managing
                dietary goals, and making personalized grocery choices, leading
                to decision fatigue and suboptimal purchases.
              </p>
              <h2>Value Propestation</h2>
              <p>
                An AR-powered grocery shopping assistant that helps you collect
                calories and make customized shopping suggestions.{" "}
              </p>
              <h2>Technology</h2>
              <ul>
                <li>
                  {" "}
                  <strong>Swift:</strong> ARkit, CoreML
                </li>
              </ul>
              <h2>Team</h2>
              <ul>
                <ul>
                  <li style={{ marginLeft: "25px" }}>
                    <a
                      href="https://www.linkedin.com/in/hillel-tladi-12532a166/"
                      style={{ color: "inherit" }}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      Hillel Tladi
                    </a>
                  </li>
                  <li style={{ marginLeft: "25px" }}>
                    <a
                      href="https://www.linkedin.com/in/jennyzxc/"
                      style={{ color: "inherit" }}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      Jenny Xuechen Zhang
                    </a>
                  </li>
                </ul>
              </ul>
              <div>
              <h2>Status</h2>
              <p style={{ display: "flex", alignItems: "center" }}>
                <span
                  style={{
                    width: "8px",
                    height: "8px",
                    backgroundColor: "#6C757D",
                    borderRadius: "50%",
                    display: "inline-block",
                    marginRight: "8px",
                  }}
                ></span>
                Offline
              </p>
            </div>             </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GroNutruiDetail;
